/**
 * @package
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class AddressData
 */
import { KladrSubject } from '@/modules/backend/Entities/KladrSubject';

export class AddressData {
  public static fromKladrSubject(subject: KladrSubject): AddressData {
    const self = new AddressData();

    self.zip = subject.getZip();

    if (subject.getParentStreet() === undefined) {
      throw new Error('Street of building doesnt exists.');
    }

    const parentStreet = subject.getParentStreet() as KladrSubject;

    self.street = `${parentStreet.getTypeShort()} ${parentStreet.getName()}`;
    self.name = `${subject.getName()}`;

    return self;
  }

  public name!: string;
  public zip!: number;
  public street!: string;
}
